/* eslint-disable no-nested-ternary */
import React, { FC, useEffect } from 'react';
import { t } from 'i18next';
import { useFormApi } from 'informed';
import moment from 'moment';
import { setHours, setMinutes } from 'date-fns';
import { notEmptyValidator } from '@common/utils';
import { MultiSteps } from '@common/interfaces';
import { DateField } from '../../../../../legacyInputs';
import css from '../styles.module.scss';

const TIME_INTERVAL = 15;

const PickupTimeReturnField: FC = () => {
  const formApi = useFormApi();

  const dropoff_time = formApi.getValue(`${MultiSteps.TripInfo}.dropoff_time`) as Date;
  const dropoff_time_return = formApi.getValue(
    `${MultiSteps.ReturnTrip}.dropoff_time_return`,
  ) as Date;
  const dropoff_date = formApi.getValue(`${MultiSteps.TripInfo}.dropoff_date`) as Date;
  const pickup_date_return = formApi.getValue(
    `${MultiSteps.ReturnTrip}.pickup_date_return`,
  ) as Date;

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore: Unreachable code error
  const dropoff_time_initial = formApi.getInitialValue(
    `${MultiSteps.TripInfo}.dropoff_time`,
  ) as Date;

  const isSameDate = moment(pickup_date_return).isSame(dropoff_date, 'day');

  useEffect(() => {
    if (dropoff_time) {
      formApi.setValue(`${MultiSteps.ReturnTrip}.pickup_time_return`, dropoff_time);
    }
  }, [dropoff_time]);

  return (
    <div className={css.field} data-testid="mobility-planner-edit-form-pick-up-time-return">
      <DateField
        className={css.input}
        dateFormat="HH:mm"
        label={t('bookingDetails.pickupTime')}
        maxTime={
          isSameDate
            ? dropoff_time || dropoff_time_initial
              ? setHours(setMinutes(new Date(), 45), 23)
              : undefined
            : undefined
        }
        minTime={isSameDate ? dropoff_time || dropoff_time_initial : undefined}
        name="pickup_time_return"
        showTimeSelect
        showTimeSelectOnly
        timeCaption={undefined}
        timeFormat="HH:mm"
        timeIntervals={TIME_INTERVAL}
        validate={notEmptyValidator}
        onChange={(value) => {
          if (
            moment(value).isAfter(dropoff_time_return) ||
            moment(value).isSame(dropoff_time_return)
          ) {
            formApi.setValue(
              `${MultiSteps.ReturnTrip}.dropoff_time_return`,
              moment(value).add(TIME_INTERVAL, 'minutes').toDate(),
            );
          }
        }}
      />
    </div>
  );
};

export default PickupTimeReturnField;
